// extracted by mini-css-extract-plugin
export var headerCell = "_x-1";
export var loadingSpinnerContainer = "_x-4";
export var rowWrapper = "_x-3";
export var standaloneTable = "_x-5";
export var table = "_x-0";
export var white = "_x-2";